<template>
  <section class="mb-4 pt-3">
    <div class="container sm-px-0">
      <div class="row">

<!--        <div class="col-xl-3">-->
<!--          <div class="bg-white shadow-sm rounded mb-3">-->
<!--            <div class="fs-15 fw-600 p-3 border-bottom">-->
<!--              {{ $t("类别") }}-->
<!--            </div>-->
<!--            <van-cell v-for="cate in cateList" :key="cate.id" :title="$t(cate.name)" is-link @click="selectCate(cate)"></van-cell>-->
<!--          </div>-->
<!--          <div class="bg-white shadow-sm rounded mb-3">-->
<!--            <div class="fs-15 fw-600 p-3 border-bottom">-->
<!--              {{ $t("价格范围") }}-->
<!--            </div>-->
<!--            <div class="p-3">-->
<!--              <el-slider-->
<!--                  v-model="priceRange"-->
<!--                  range-->
<!--                  :max="parseInt(paramMapAll['SHOP_GOODS_BUYER_PRICE_FILTER_MAX']||100000)"-->
<!--                  @change="onSliderChange"-->
<!--              />-->
<!--              <div class="row mt-2">-->
<!--                <div class="col-6">-->
<!--                    <span class="range-slider-value value-low fs-14 fw-600 opacity-70" data-range-value-low="2437.96" id="input-slider-range-value-low">{{ priceRange[0] }}</span>-->
<!--                </div>-->
<!--                <div class="col-6 text-right">-->
<!--                    <span class="range-slider-value value-high fs-14 fw-600 opacity-70" data-range-value-high="6635.00" id="input-slider-range-value-high">{{ priceRange[1] }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="col-lg-12">
          <div class="d-flex-between-center">
            <ul class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end">
              <li class="breadcrumb-item opacity-50">
                <router-link class="text-reset" to="/">{{ $t("首页") }}</router-link>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset">{{ $t("限时秒杀") }}</a>
              </li>
            </ul>
            <div>
              <label class="mb-0 opacity-50 u-m-r-10">{{ $t("排序方式") }}</label>
              <zselect v-model="selectedSortOptionId" :dict-list="sortOptions" list-code="id" list-label="name" @change="selectSortOption"></zselect>
            </div>
          </div>
          <div class="goods-content">
            <van-empty
                v-if="!goodsList || goodsList.length === 0"
                :description="$t('没有找到符合条件的商品')"
            />
            <div
                v-else
                class="row gutters-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-4 row-cols-md-3 row-cols-2"
            >
              <div
                  v-for="goods in goodsList"
                  :key="`${goods.shopId}_${goods.id}`"
                  class="col"
              >
                <ProductCard :item="goods" is-seckill/>
              </div>
            </div>
            <PaginationComp
                :cur-page="curPage"
                :total-page="totalPage"
                @goto="goToPage"
            />
          </div>
        </div>
      </div>

    </div>
  </section>
</template>
<script>
import ProductCard from "@/components/ProductCard.vue";
import PaginationComp from "@/components/PaginationComp.vue";
import { getListCates } from "@/api/goods.js";

export default {
  name: "productList",
  components: { PaginationComp, ProductCard},
  watch: {
    $route: {
      handler() {
        this.refresh();
      }
    }
  },
  data() {
    const sortOptions = [
      {
        id: 1,
        name: "最新",
        orders: [{column: "`storeGoods.createTime`", asc: false}]
      },
      {
        id: 2,
        name: "最旧",
        orders: [{column: "`storeGoods.createTime`", asc: true}]
      },
      {
        id: 3,
        name: "价格从低到高",
        orders: [{column: "`storeGoods.price`", asc: true}]
      },
      {
        id: 4,
        name: "价格从高到低",
        orders: [{column: "`storeGoods.price`", asc: false}]
      }
    ];
    return {
      totalPage: 0,
      curPage: 0,
      cateList: [],
      goodsList: [],

      goodsCateName: "",
      goodsCateCode: null,
      goodsBrandName: "",
      goodsBrandCode: null,
      searchText: "",

      sortOption: "",
      showSortSelect: false,
      sortOptions,
      selectedSortOptionId: 1,
      randomMulti: parseInt(Math.random() * new Date().getTime()),

      priceRange: [0, 0],
      sidebarActive: false,
      paramsMore: {},
    };
  },
  computed: {
    selectedSortOption() {
      return this.sortOptions.find(
          option => option.id === this.selectedSortOptionId
      );
    }
  },
  created() {
    this.getCateList()
    this.refresh();
  },
  methods: {
    async getCateList() {
      this.cateList = (await getListCates()).data;
    },
    async pageGoods() {
      const pageSize = 20;
      let params = {
        isSeckill: true, // 只加载有效的限时秒杀商品
        curPage: this.curPage,
        pageSize,
        goodsCateCode: this.goodsCateCode,
        goodsBrandCode: this.goodsBrandCode,
        randomMulti: this.randomMulti,
        searchText: this.searchText,
        orders: this.selectedSortOption.orders,
        priceMin: this.priceRange[0],
        ...this.paramsMore
      }
      const priceMax = this.priceRange[1]
      if (priceMax > 0) {
        params.priceMax = priceMax
      }
      const res = await this.$get("/goods/page", {
        params: params
      });
      const page = res.data;
      this.goodsList = page.records || [];
      this.totalPage = Math.ceil(parseInt(page.total) / pageSize);
      window.scrollTo(0, 0);
    },
    goToPage(page) {
      console.log("goToPage", page);
      if (typeof page !== "number" || page < 1 || page > this.totalPage) return;
      this.curPage = page;
      this.pageGoods();
    },
    selectCate(cate) {
      this.goodsCateCode = cate.id
      this.pageGoods();
    },
    selectSortOption(optionId) {
      this.selectedSortOptionId = optionId;
      this.pageGoods();
    },
    refresh() {
      this.goodsCateName = decodeURIComponent(this.$route.query.cateName || "");
      this.goodsCateCode = this.$route.query.cateCode;
      this.goodsBrandName = this.$route.query.brandName;
      this.goodsBrandCode = this.$route.query.brandCode;
      this.searchText = this.$route.query.keyword;
      this.curPage = 1;
      this.pageGoods();
    },
    onSliderChange() {
      this.sidebarActive = false;
      this.refresh();
    }
  },
};
</script>
